export default __webpack_public_path__ + "static/media/GSP8.321a81d3.png";